import { styled } from 'libs/ui/styled';

export const IconContentStyled = styled('div')(() => ({
  marginTop: 5,
  height: 16,
}));
